export default __webpack_public_path__ + "static/media/verify-letter-red.1780221e.svg";